import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/getCorridorPois'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class getCorridorPoisStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "getCorridorPoisStore",
			variables: true,
		})
	}
}

export async function load_getCorridorPois(params) {
  await initClient()

	const store = new getCorridorPoisStore()

	await store.fetch(params)

	return {
		getCorridorPois: store,
	}
}
